export default function determineView({ path, state }) {
  const view = state.get('app.currentView')
  switch (true) {
    case view === 'media' && state.get('media.showDetail'):
      return path.detailedView()
    case view === 'media':
      return path.mediaView()
    default:
      return path.other()
  }
}



// WEBPACK FOOTER //
// ./src/modules/Media/actions/determineView.js